import React from 'react';
import PropTypes from 'prop-types';

import Button, { ButtonGroup } from '../../../../library/button/button';

import './fitment-confirmation.scss';

function FitmentConfirmation(props) {
  const { fitmentConfirmationText, onCancelFitment, onConfirmFitment } = props;

  return (
    <div styleName="fitment-confirmation">
      <h1>Confirm Change?</h1>
      <p>{fitmentConfirmationText}</p>
      <ButtonGroup className="fitment-confirmation-buttons" layout="vertical">
        <Button isPrimary onClick={() => onConfirmFitment?.()}>
          Change & Continue
        </Button>
        <Button isSecondary onClick={() => onCancelFitment?.()}>
          Cancel Edit
        </Button>
      </ButtonGroup>
    </div>
  );
}

FitmentConfirmation.propTypes = {
  fitmentConfirmationText: PropTypes.string,
  onCancelFitment: PropTypes.func,
  onConfirmFitment: PropTypes.func
};

export default FitmentConfirmation;
